import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import StaffAttendanceTable from "../attendance/staff/staff-attendance-table";
import { fetchMyAttendancePage, selectStaffAttendances } from "../attendance/staff-attendance.slice";
import { getDefaultStaffAttendanceSearchCriteria } from "../../service/model/staff-attendance.model";

const MyAttendance = () => {
    const dispatch = useAppDispatch();
    const attendances = useAppSelector(selectStaffAttendances); 

    useEffect(() => {
        dispatch(fetchMyAttendancePage(getDefaultStaffAttendanceSearchCriteria()))
    }, []);

    return (
        <div>
            <StaffAttendanceTable staffAttendances={attendances} isProfileView={true} />
        </div>
    );
};

export default MyAttendance;